const JSON_HEADERS = { "Content-Type": "application/json" };

const SALES_BASE =
  import.meta.env.VITE_SALES_API_BASE ||
  import.meta.env.VITE_API_BASE ||
  import.meta.env.VITE_API_BASE_URL ||
  "https://u5aw5omfkd.execute-api.us-east-2.amazonaws.com/dev";

function joinUrl(base, path) {
  if (!base) return path;
  const trimmed = base.endsWith("/") ? base.slice(0, -1) : base;
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${trimmed}${normalized}`;
}

function authHeaders(jwt) {
  return jwt ? { Authorization: `Bearer ${jwt}` } : {};
}

async function handleResponse(res, friendlyContext) {
  if (res.status === 403) {
    throw new Error("User Action Not Authorized");
  }
  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    const msg = friendlyContext || `HTTP ${res.status}`;
    try {
      const j = JSON.parse(txt);
      throw new Error(j?.error || msg);
    } catch {
      throw new Error(msg);
    }
  }
}

export async function searchOffers(jwt, query) {
  const encoded = encodeURIComponent(query || "");
  const url = joinUrl(
    SALES_BASE,
    `/tracking-search?query=${encoded}&q=${encoded}`
  );
  const res = await fetch(url, { headers: { ...authHeaders(jwt) } });
  await handleResponse(res, "Search failed");
  const data = await res.json();
  return data?.results || data?.items || data || [];
}

export async function getOfferDetails(jwt, offerId) {
  const url = joinUrl(
    SALES_BASE,
    `/offer-details?offerId=${encodeURIComponent(offerId)}`
  );
  const res = await fetch(url, { headers: { ...authHeaders(jwt) } });
  if (res.status === 403) return null;
  await handleResponse(res, "Failed to load details");
  return await res.json();
}

export async function getOfferRead(jwt, offerId) {
  const url = joinUrl(
    SALES_BASE,
    `/offer-read?offerId=${encodeURIComponent(offerId)}`
  );
  const res = await fetch(url, { headers: { ...authHeaders(jwt) } });
  await handleResponse(res, "Failed to load offer");
  return await res.json();
}

export async function saveOfferTracking(jwt, payload) {
  const url = joinUrl(SALES_BASE, "/offers");
  const res = await fetch(url, {
    method: "PUT",
    headers: { ...JSON_HEADERS, ...authHeaders(jwt) },
    body: JSON.stringify(payload || {}),
  });
  await handleResponse(res, "Save failed");
  return await res.json();
}

export async function createOffer(jwt, payload) {
  const url = joinUrl(SALES_BASE, "/offers");
  const res = await fetch(url, {
    method: "POST",
    headers: { ...JSON_HEADERS, ...authHeaders(jwt) },
    body: JSON.stringify(payload || {}),
  });
  await handleResponse(res, "Save failed");
  return await res.json();
}
